module.exports = __webpack_public_path__ + "img/france-respiratory-diseases-male.fd147d03.png";